import {
  LOAD_BAR_CHART,
  SET_COUNT_GIFTS_SENT,
  RESET_REPORT_STATE,
  SET_HISTORICAL_ORDERS_SENT_OBJECT,
  LOAD_TRENDING_GIFTS,
  SET_TRENDING_GIFTS,
  LOAD_SHIPMENTS_METRICS,
  SET_AVERAGE_SHIPMENTS,
  SET_REMAINING_SHIPMENTS,
  SET_SHIPMENT_CHART_DATA,
  SET_AVERAGE_SHIPMENT
} from '../mutationTypes'
import reportStoreDefaultState from '@/state/reportStore/reportStoreDefaultState'

export default {
  [LOAD_BAR_CHART](state, payload) {
    state.loadBarChart = payload
  },
  [SET_COUNT_GIFTS_SENT](state, payload) {
    state.countGiftsSent = payload
  },
  [SET_HISTORICAL_ORDERS_SENT_OBJECT](state, payload) {
    state.historicalOrdersSent = payload
  },
  [LOAD_TRENDING_GIFTS](state, payload) {
    state.loadingTrendingGifts = payload
  },
  [SET_TRENDING_GIFTS](state, payload) {
    state.trendingGiftsList = payload
  },
  [LOAD_SHIPMENTS_METRICS](state, payload) {
    state.loadAvergaShipments = payload
  },
  [SET_AVERAGE_SHIPMENTS](state, payload) {
    state.averageShipments = payload
  },
  [SET_REMAINING_SHIPMENTS](state, payload) {
    state.remainingShipments = payload
  },
  [SET_SHIPMENT_CHART_DATA](state, payload) {
    state.shipmentsChartData = payload
  },
  [RESET_REPORT_STATE](state) {
    Object.assign(state, reportStoreDefaultState())
  },
  [SET_AVERAGE_SHIPMENT](state, payload) {
    state.averageShipment = payload
  }
}
